import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useFeatureFlags } from 'libs.flags.react';
import { useLocalizeMessage } from 'libs.nucleus';
import { appendSiteIdToPath } from '../../helpers/links.helpers';
import { extractClassicAppsBaseUrl } from '../../helpers/study.helpers';
// import { TEnvironment } from '../../types/studies_list.types';
import { LUMOS_PERMISSIONS } from '../../types/permissions.types';
import { useCurrentEnvironment } from '../use_current_environment';
import { useLumosAuth } from '../use_lumos_auth';
import { usePIOversightAccess } from '../use_pi_oversight_access';
import { useSiteContext } from '../use_site_context';
export const useNavigation = () => {
    const { studyId } = useParams();
    const { _id } = useSiteContext();
    const { environment } = useCurrentEnvironment();
    const { isUserPermitted } = useLumosAuth();
    const translate = useLocalizeMessage();
    const isPIOversightEnabled = usePIOversightAccess();
    const { isFeatureEnabled } = useFeatureFlags();
    const canViewUserTrainingReports = isUserPermitted(LUMOS_PERMISSIONS.SITE_USERS_TRAINING_REPORTS);
    const isSiteReportsEnabled = isFeatureEnabled('LibraryReportsBuilder');
    const getExternalAppUrl = (appName, path) => {
        if (!environment) {
            return '';
        }
        return `${extractClassicAppsBaseUrl(environment.cortexURL, appName)}${path}?orgCode=${environment.code}`;
    };
    const navItems = useMemo(() => {
        const items = [
            // TODO: Site Dashboard should be added after MVP
            // { title: translate('generic.home'), path: `/site/study/${studyId}/home`, icon: 'navCube' },
            {
                title: translate('generic.participants'),
                path: `/site/study/${studyId}/participants`,
                icon: 'navUsers',
            },
            {
                title: translate('generic.pi_signature'),
                path: `/site/study/${studyId}/oversight`,
                icon: 'navConsent',
                hidden: !isPIOversightEnabled,
            },
            {
                title: translate('label.navigation.data_changes'),
                path: getExternalAppUrl('datachange', ''),
                icon: 'navProtocol',
                externalIcon: true,
                target: '_blank',
            },
            {
                title: translate('label.navigation.study_data'),
                path: getExternalAppUrl('portal', '/reports'),
                icon: 'navData',
                externalIcon: true,
                target: '_blank',
            },
            {
                title: translate('generic.queries'),
                path: appendSiteIdToPath(getExternalAppUrl('site', '/queries'), _id),
                icon: 'navQueries',
                externalIcon: true,
                target: '_blank',
            },
            {
                title: translate('Reports'),
                path: `/site/study/${studyId}/reports`,
                icon: 'documentChartBar',
                hidden: !isSiteReportsEnabled,
            },
            {
                title: translate('label.navigation.help_resources'),
                path: `/site/study/${studyId}/help-support`,
                icon: 'navWorkflows',
            },
            {
                title: translate('generic.user_training_reports'),
                path: `/site/study/${studyId}/user-training-reports`,
                icon: 'navProtocol',
                hidden: !canViewUserTrainingReports,
            },
        ];
        return items;
    }, [environment, _id, isPIOversightEnabled, isSiteReportsEnabled]);
    return { navItems };
};
